import { Injectable } from "@angular/core";
import { environment } from "@env/environment";

import { ApiService } from "../api/api.service";
import { Automation } from "../../models/automation/automation.model";

@Injectable({
	providedIn: "root",
})
export class AutomationsService {
	constructor(private apiService: ApiService) {}

	fetchAutomations(options?: any) {
		return this.apiService.get(`${environment.api_base_url}/automations`, options);
	}

	fetchAutomation(automationId: number, options?: any) {
		return this.apiService.get(`${environment.api_base_url}/automations/${automationId}`, options);
	}

	addAutomation(automation: Automation, options?: any) {
		return this.apiService.post(`${environment.api_base_url}/automations`, automation, options);
	}

	updateAutomation(automationId: number, automation: Automation, options?: any) {
		return this.apiService.put(`${environment.api_base_url}/automations/${automationId}`, automation, options);
	}

	activateDeactivateAutomation(automationId: number, activate: boolean, options?: any) {
		const activateDeactivate = activate ? "activate" : "deactivate";
		return this.apiService.put(`${environment.api_base_url}/automations/${automationId}/${activateDeactivate}`, null, options);
	}

	deleteAutomation(id: number, options?: any) {
		return this.apiService.delete(`${environment.api_base_url}/automations/${id}`, options);
	}
}
